<template>
    <el-tooltip :content="name" :open-delay="1000" placement="top-start">
        <el-checkbox :label="value" :checked="checked">{{ name }}</el-checkbox>
    </el-tooltip>
</template>

<script>
export default {
    name: 'CheckboxTooltip',
    props: {
        value: {
            type: [String, Number, Boolean],
            required: true
        },
        name: {
            type: [String, Number, Boolean],
            required: true
        },
        checked: {
            type: [Boolean],
            default: false
        }
    }
};
</script>
